import mediaUpInitTx from "./mediaUpInitTx";
function mediaAllInitTx(){
  const WRAPPER = '.media-wrapper-tx'
  $(WRAPPER).each(function (){
    new mediaUpInitTx(this)
  })
}

export default mediaAllInitTx
